import { render, staticRenderFns } from "./EmployeeRegFormPage.vue?vue&type=template&id=c8a027d8&scoped=true&"
import script from "./EmployeeRegFormPage.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegFormPage.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRegFormPage.vue?vue&type=style&index=0&id=c8a027d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a027d8",
  null
  
)

export default component.exports